import { Save } from 'lucide-react';
import { OfflinePill, SaveStatusPill, toSaveStatus } from './saveStatus';

interface SaveStatusIndicatorProps {
  isOnline: boolean;
  isSaving: boolean;
  isDirty: boolean;
  hasOfflineEdits: boolean;
  hasContent: boolean;
  onSave: () => void;
}

export function SaveStatusIndicator({
  isOnline,
  isSaving,
  isDirty,
  hasOfflineEdits,
  hasContent,
  onSave,
}: SaveStatusIndicatorProps) {
  const status = toSaveStatus({ isSaving, isDirty, hasOfflineEdits, hasContent });

  return (
    <div className="flex items-center gap-2">
      {!isOnline && <OfflinePill />}
      {status === 'dirty' ? (
        <button
          type="button"
          onClick={onSave}
          className="inline-flex items-center gap-1.5 px-3 py-1 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
        >
          <Save className="h-3.5 w-3.5" />
          Save
        </button>
      ) : (
        <SaveStatusPill status={status} />
      )}
    </div>
  );
}
